$(function() {
  var audio = null;
  var pause_obj = null;
	function getMusicUrl(obj){
		let product_code = obj.data("product_code");
		let disk_no = obj.data("disk_no");
		let music_no = obj.data("music_no");
    let music_url = 'https://download.della.co.jp/play_sample/' + product_code + '/' + disk_no + '/' + music_no;
    return music_url;
	}
  $('.play').each(function(index, element){
    let music_url = getMusicUrl($(this));
    let $this = $(this);
    $.get(music_url,function(data){
      if (data == "error") {
        $this.hide();
      }
    });
  });
  $(document).on('click','.play',function(){
      let music_url = getMusicUrl($(this));
      if (audio != null) {
        audio.pause();
        audio.currentTime = 0;
        pause_obj.parent().find(".stop").hide();
        pause_obj.show();
      }
      audio = new Audio(music_url);
      audio.load();
      audio.play();
      $(this).parent().find(".stop").show();
      $(this).hide();
      pause_obj = $(this);
  });
  $(document).on('click','.stop',function(){
    audio.pause();
    audio = null;
		$(this).parent().find(".playAlbum").show();
		$(this).parent().find(".play").show();
		$(this).hide();
    pause_obj = $(this);
	});

  //試聴曲を次々と再生
  $('.playAlbum').each(function(index, element){
    let music_url = getMusicUrl($(this));
    let $this = $(this);
    $.get(music_url,function(data){
      if (data == "error") {
        $this.hide();
      }
    });
  });
  $(document).on('click','.playAlbum',function(){
    let music_url = getMusicUrl($(this));
    let thisObj = $(this);
    if (audio != null) {
      audio.pause();
      audio.currentTime = 0;
      $('.stop').hide();
      $('.playAlbum').show();
    }
    audio = new Audio(music_url);
    audio.addEventListener("ended",{obj: thisObj, handleEvent: audioEnded},false); // 終了イベント処理関数設定
    audio.load();
    audio.play();
    $(this).parent().find(".stop").show();
    $(this).hide();
	});
  async function audioEnded(e){ // 終了イベントを受ける関数
    let $this = this.obj;
    //一旦リンクを戻す
		$this.parent().find(".playAlbum").show();
		$this.parent().find(".stop").hide();
    let disk_no = $this.parent().find(".playAlbum").data('disk_no');
    let music_no = $this.parent().find(".playAlbum").data('music_no');

    //次の曲をセット
    dataSetAlbum($this.parent().find(".playAlbum") , disk_no ,(parseInt(music_no) + 1));

    let music_url = getMusicUrl($this);
    let result = await isMusic(music_url);
    //次の曲が存在すれば再生
    if (result) {
      $this.parent().find(".playAlbum").trigger('click');
    }
    //次の曲が存在しなければディスクを入れ替えて1曲目から
    else {
      dataSetAlbum($this.parent().find(".playAlbum") ,(parseInt(disk_no) + 1) ,'1');
      music_url = getMusicUrl($this);
      result = await isMusic(music_url);
      if (result) {
        $this.parent().find(".playAlbum").trigger('click');
      }
      //全てなければdataを初期値に戻す
      else {
        dataSetAlbum($this.parent().find(".playAlbum"),'1','1');
      }
    }
  }
  //playAlbumのデータセット
  function dataSetAlbum(obj,disk_no,music_no){
    obj.data('disk_no', disk_no);
    obj.data('music_no', music_no);
  }
  //視聴音源の有無
  function isMusic(music_url){
    return new Promise((resolve, reject) => {
      $.get(music_url,function(data){
        if (data == "error") {
          resolve(false);
        }
        else {
          resolve(true);
        }
      })
    })
  }
});
